import { render, staticRenderFns } from "./documentcomments.vue?vue&type=template&id=66b2bdbe&"
import script from "./documentcomments.vue?vue&type=script&lang=js&"
export * from "./documentcomments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports